<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;">系统设置</span>
      / 员工设置
    </div>
    <div class="school-user-list">
      <section>
        <el-button type="primary" @click="gotoCreateUser" size="small" v-if="$attrs.methodAuthTabView('员工权限', '新建账号')">新建账号</el-button>
        <el-form ref="ruleForm" :inline="true" :model="ruleForm" class="form-style" size="small">
          <el-form-item label="姓名" prop="realname">
            <el-input v-model="ruleForm.realname" placeholder="请输入姓名" style="width: 150px"></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="username">
            <el-input v-model="ruleForm.username" placeholder="请输入账号" style="width: 150px"></el-input>
          </el-form-item>
          <el-form-item label="在职/离职" prop="state">
            <el-select v-model="ruleForm.state" placeholder="请选择" style="width: 150px">
              <el-option label="在职" value="在职"></el-option>
              <el-option label="离职" value="离职"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="角色" prop="role_id">
            <el-select v-model="ruleForm.role_id" placeholder="请选择" style="width: 150px">
              <el-option v-for="item in roleList" :key="item.value" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getUserList">查询</el-button>
            <el-button @click="reSize('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="table-style">
          <el-table size="small" :data="tableData" :header-cell-style="{
              background: '#f5f7fa',
              color: '#909399',
              'font-size': '14px',
            }" stripe>
            <!-- <el-table-column type="selection" width="55">
            </el-table-column> -->
            <el-table-column fixed="left" width="50" align="center" label="序号">
              <template slot-scope="scope">
                {{ scope.$index + 1 + (page_no - 1) * page_size }}
              </template>
            </el-table-column>
            <el-table-column fixed="left" align="left" width="100" prop="realName" label="姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.realName }}</span>
                <span v-if="scope.row.principal" style="color: #409eff">(超管)</span>
              </template>
            </el-table-column>

            <el-table-column align="center" width="50" prop="sex" label="性别"></el-table-column>
            <el-table-column align="left" width="120" prop="name" label="账号"></el-table-column>

            <el-table-column width="50" align="left" label="家校通">
              <template slot-scope="scope">
                <span v-if="$store.state.user.schoolInfo.authorize">
                  <span v-if="scope.row.authorizerOpenid">
                    <span v-if="scope.row.weNickname">
                      {{ scope.row.weNickname }}
                    </span>
                    <span v-else>已绑定</span>
                  </span>
                  <span v-else>
                    <el-tooltip class="item" effect="dark" content="邀请老师绑定家校通,接收学员动态通知。" placement="top">
                      <el-link @click="getQrCode(scope.row)" type="primary">绑定</el-link>
                    </el-tooltip>
                  </span>
                </span>
                <span v-else>
                  <span v-if="scope.row.openid">
                    <span v-if="scope.row.weNickname">
                      {{ scope.row.weNickname }}
                    </span>
                    <span v-else>已绑定</span>
                  </span>
                  <span v-else>
                    <el-tooltip class="item" effect="dark" content="邀请老师绑定家校通,接收学员动态通知。" placement="top">
                      <el-link @click="getQrCode(scope.row)" type="primary">绑定</el-link>
                    </el-tooltip>
                  </span>
                </span>
              </template>
            </el-table-column>

            <el-table-column align="left" width="200" prop="eduCampusName" label="所属校区" :show-overflow-tooltip="true">
            </el-table-column>

            <el-table-column align="left" prop="roleNames" label="角色" :show-overflow-tooltip="true">
              <!-- width="250" -->
            </el-table-column>
            <el-table-column align="center" width="160" prop="teachingScope" label="授课范围"></el-table-column>
            <el-table-column align="left" width="50" prop="state" label="状态"></el-table-column>

            <el-table-column width="150" prop="createdTime" label="创建日期">
            </el-table-column>

            <el-table-column width="80" align="center" fixed="right" label="操作">
              <template slot-scope="scope">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    操作<i class="el-icon-arrow-down"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="getQrCode(scope.row)" v-if="
                        $store.state.user.schoolInfo.authorize &&
                          !scope.row.authorizerOpenid
                      ">绑定微信</el-dropdown-item>

                    <el-dropdown-item @click.native="getQrCode(scope.row)" v-else-if="
                        !$store.state.user.schoolInfo.authorize &&
                          !scope.row.openid
                      ">绑定微信</el-dropdown-item>

                    <el-dropdown-item @click.native="deleteUserOpenId(scope.row)" v-if="
                        $store.state.user.schoolInfo.authorize &&
                          scope.row.authorizerOpenid
                      ">解绑微信</el-dropdown-item>
                    <el-dropdown-item @click.native="deleteUserOpenId(scope.row)" v-else-if="
                        !$store.state.user.schoolInfo.authorize &&
                          scope.row.openid
                      ">解绑微信</el-dropdown-item>

                    <el-dropdown-item v-if="!scope.row.is_principal" @click.native="updateUserPassword(scope.row)">重置密码</el-dropdown-item>

                    <el-dropdown-item @click.native="gotoEditUerInfo(scope.row)">编辑</el-dropdown-item>

                    <el-dropdown-item @click.native="deleteUser(scope.row)" :disabled="scope.row.principal">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 30px; text-align: right">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="page_size" layout="total, prev, pager, next" :total="total"></el-pagination>
        </div>
      </section>

      <el-dialog :title="'员工姓名:' + tch_name" :visible.sync="dialogVisible1" width="260px" :before-close="handleClose">
        <div style="text-align: center; margin-top: -20px">
          <el-image style="width: 200px; height: 200px" :src="code_url" fit="fill"></el-image>
        </div>

        <div style="text-align: center">
          <span>请老师用微信扫码,绑定账号</span>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  //  getUserList,
  deleteUser,
} from '@/api/user'
import {
  getQrCode,
  deleteUserOpenId,
  // updateUserPassword,
} from '@/api/educational'
import {
  api_schEduRoleQueryList,
  api_tchEmployeeSettingSelectEmployList,
  api_tchEmployeeSettingResetPassword,
} from '@/api/javaApi'
import CryptoJS from 'crypto-js'
export default {
  name: 'school-user-list',
  data() {
    return {
      is_principal: '',
      ruleForm: {
        username: '',
        realname: '',
        state: '在职',
        role_id: '',
      },
      roleList: [],
      tableData: [],
      total: 0,
      page_no: 1,
      page_size: 10,

      //微信绑定
      code_url: '',
      dialogVisible1: false,
      tch_name: '',
    }
  },

  watch: {
    '$store.state.user.selected_schools': {
      handler(newValue) {
        console.log('校区监听')

        if (newValue.length == 0) {
          this.$message.warning('请选择校区')
        } else {
          this.getUserList()
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.getUserList()
    this.getSchoolRoleList()
    this.is_principal = this.$store.getters.is_principal
  },
  methods: {
    handleClose() {
      this.getUserList()
      this.dialogVisible1 = false
    },

    //获得学员带参二维码
    getQrCode(row) {
      console.log('老师信息')
      console.log(row)
      console.log(row.userId)
      this.tch_name = row.realName

      getQrCode({
        userId: row.userId,
      }).then((res) => {
        console.log('绑定老师微信')
        console.log(res)

        this.code_url =
          'data:image/jpeg;base64,' +
          this.arrayBufferToBase64(res.qucodeData.data)
        console.log('url', this.code_url)

        this.dialogVisible1 = true
      })
    },

    arrayBufferToBase64(buffer) {
      let binary = ''
      const bytes = new Uint8Array(buffer)
      const len = bytes.byteLength
      for (let i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary) //base64
    },

    deleteUserOpenId(row) {
      console.log(row)
      deleteUserOpenId({
        userId: row.userId,
      }).then((res) => {
        console.log('解绑老师微信')
        if (res.is_delete) {
          this.$message.success('解绑成功')
          this.getUserList()
        }
      })
    },

    getUserList() {
      api_tchEmployeeSettingSelectEmployList({
        eduCampusId: this.$store.state.user.selected_schools[0],
        realName: this.ruleForm.realname,
        name: this.ruleForm.username,
        state: this.ruleForm.state,
        roleId: this.ruleForm.role_id,
        pageRequest: {
          pageNum: this.page_no,
          pageSize: this.page_size,
        },
      }).then((res) => {
        this.tableData = res.content
        this.total = res.totalSize
        this.tableData.forEach((item) => {
          item.teachingScope = `${item.platformTch && item.eduTch
            ? '平台、校区'
            : item.platformTch
              ? '平台'
              : item.eduTch
                ? '校区'
                : ''
            }`
        })
        console.log(res)
      })
    },

    updateUserPassword(row) {
      console.log('重置密码')
      this.$confirm(`确定重置此账号的密码为${this.$store.state.globalCheck.defaultPassword}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        api_tchEmployeeSettingResetPassword({
          userId: row.userId,
          password: CryptoJS.MD5(this.$store.state.globalCheck.defaultPassword).toString(CryptoJS.enc.Base64),
        }).then((res) => {
          console.log('重置密码')
          console.log(res)
          this.$message.success('密码重置成功')
          this.getUserList()
        })
      })
    },

    search() {
      this.page_no = 1
      this.getUserList()
    },
    getSchoolRoleList() {
      api_schEduRoleQueryList({ pageNum: 1, pageSize: 100 }).then((res) => {
        this.roleList = res.content
      })
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getUserList()
    },
    reSize(formName) {
      this.$refs[formName].resetFields()
      this.getUserList()
    },
    gotoUserInfo(row) {
      this.$router.push({
        name: 'school-user-info',
        query: {
          id: row.nick_id,
        },
      })
    },
    gotoEditUerInfo(row) {
      this.$router.push({
        name: 'school-edit-user-info',
        query: {
          id: row.userId,
        },
      })
    },
    gotoCreateUser() {
      this.$router.push({
        name: 'school-edit-user-info',
      })
    },

    deleteUser(row) {
      console.log('删除用户')
      this.$confirm('是否确认删除该用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteUser({
            userId: row.userId,
          }).then((res) => {
            console.log('删除用户')
            if (res.is_delete) {
              this.$message.success('删除成功')
              this.getUserList()
            }
          })
        })
        .catch(() => { })
    },
  },
}
</script>

<style lang="scss" scoped>
.mainNew {
  height: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.school-user-list {
  min-height: calc(100% - 30px);

  margin: 10px;

  border-radius: 5px;
  background-color: #fff;

  section {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .form-style {
    margin-top: 15px;
  }
}
</style>
